export const inputFormattingConstants = Object.freeze({
  dateFormats: {
    MMDDYYYY: 'MM/DD/YYYY',
    MMDDYYYYHHmmA: 'MM/DD/YYYY HH:mm A',
  },
})
